import deleteMailListRows from './deleteMailListRows';
export default function emptySearchTableView(tableView) {
    return deleteMailListRows(tableView.rowKeys, tableView.id, false /* isExplicitSoftDelete */);
}
//# sourceMappingURL=emptySearchTableView.js.map